import { useCallback, useEffect, useState } from 'react';

export function useColumnVisibility(storageKey?: string) {
  const sessionKey = storageKey ? `columnVisibility_${storageKey}` : null;

  const [userColumnVisibility, setUserColumnVisibility] = useState<Record<string, boolean>>(() => {
    if (!sessionKey) return {};
    try {
      const stored = sessionStorage.getItem(sessionKey);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)) {
          return parsed as Record<string, boolean>;
        }
      }
    } catch {
      // ignore storage errors
    }
    return {};
  });

  useEffect(() => {
    if (!sessionKey) return;
    try {
      sessionStorage.setItem(sessionKey, JSON.stringify(userColumnVisibility));
    } catch {
      // ignore storage errors
    }
  }, [userColumnVisibility, sessionKey]);

  const handleToggle = useCallback((id: string) => {
    setUserColumnVisibility((prev) => ({ ...prev, [id]: prev[id] === false }));
  }, []);

  return { userColumnVisibility, handleToggle };
}
